import classNames from 'classnames';
import React from 'react';

interface ButtonProps {
  type?: 'button' | 'submit';
  theme?: 'default' | 'primary';
  size?: 'sm' | 'md';
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ type, theme, size, className, onClick, children, disabled }, ref) => {
    const getSizeClass = () => {
      switch (size) {
        case 'sm':
          return 'ceas-text-sm ceas-px-4 ceas-py-2';
          break;
        case 'md':
          return 'ceas-px-6 ceas-py-3';
          break;
        default:
          return '';
          break;
      }
    };

    return (
      <button
        ref={ref}
        type={type}
        className={classNames(
          theme === 'default'
            ? 'ceas-border ceas-border-gray-300 ceas-bg-white hover:ceas-bg-gray-50'
            : 'ceas-border-transparent ceas-text-white ceas-bg-primary-600 hover:ceas-bg-primary-700',
          getSizeClass(),
          className,
          'ceas-inline-flex ceas-items-center ceas-mb-2 ceas-border ceas-font-medium ceas-rounded-md ceas-shadow-sm focus:ceas-outline-none focus:ceas-ring-2 focus:ceas-ring-offset-2 focus:ceas-ring-primary-500'
        )}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }
);

Button.defaultProps = {
  type: 'button',
  theme: 'default',
  size: 'md',
  className: '',
  onClick: () => {},
};

export default Button;
